<script setup lang="ts">
import {
  PhCaretRight,
  PhGearSix,
  PhInfo,
  PhListBullets,
  PhSignOut,
  PhUserCircle,
  PhUserGear,
} from "@phosphor-icons/vue";

const appIconPath = "/icons/icon48.png";
</script>

<template>
  <header id="appHeader" class="app-header">
    <div class="title-lockup">
      <img class="app-icon" :src="appIconPath" alt="" width="34" height="34" />
      <div class="title-copy">
        <h1>图萃 · 1688 素材整理</h1>
      </div>
    </div>
    <div id="headerActions" class="header-actions">
      <button
        id="settingsButton"
        class="header-icon-button"
        type="button"
        aria-label="设置"
        title="设置"
      >
        <PhGearSix :size="19" weight="bold" aria-hidden="true" />
      </button>
      <button
        id="accountButton"
        class="header-icon-button header-account-button"
        type="button"
        aria-label="登录"
        aria-haspopup="menu"
        aria-expanded="false"
        title="登录"
        hidden
      >
        <PhUserCircle class="header-account-icon" :size="20" weight="bold" aria-hidden="true" />
        <span id="headerAccountAvatar" class="account-avatar header-account-avatar" aria-hidden="true">A</span>
      </button>
    </div>

    <div id="accountPopover" class="account-popover" role="dialog" aria-label="账号菜单" hidden>
      <div class="account-popover-profile">
        <span id="accountMenuAvatar" class="account-avatar" aria-hidden="true">A</span>
        <div>
          <strong id="accountMenuNickname">—</strong>
          <div class="account-points-line">
            <span class="account-points-label">点数</span>
            <span class="account-balance">
              <strong id="accountPoints">—</strong>
              <span id="accountPointsHelp" class="account-points-help" hidden>
                <button type="button" aria-label="了解点数" aria-describedby="accountPointsTooltip">
                  <PhInfo :size="13" weight="bold" aria-hidden="true" />
                </button>
                <span id="accountPointsTooltip" class="account-points-tooltip" role="tooltip">
                  点数用于支付图片分析等在线服务。
                </span>
              </span>
            </span>
            <span id="accountPointsDivider" class="account-points-divider" aria-hidden="true" hidden></span>
            <button id="rechargeButton" class="account-recharge-button" type="button" disabled hidden title="充值服务暂未开放">
              充值
            </button>
          </div>
        </div>
      </div>

      <div class="account-menu-items">
        <button id="accountSettingsButton" class="account-menu-item" type="button">
          <PhUserGear :size="17" weight="bold" aria-hidden="true" />
          <span>账号设置</span>
          <PhCaretRight class="account-menu-chevron" :size="15" weight="bold" aria-hidden="true" />
        </button>
        <button id="usageDetailsButton" class="account-menu-item" type="button" disabled title="使用明细暂未开放">
          <PhListBullets :size="17" weight="bold" aria-hidden="true" />
          <span>使用明细</span>
          <small>暂未开放</small>
        </button>
      </div>

      <button id="accountMenuLogoutButton" class="account-menu-item account-menu-logout" type="button">
        <PhSignOut :size="17" weight="bold" aria-hidden="true" />
        <span>退出登录</span>
      </button>
    </div>
  </header>
</template>
